import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import Helper from '../../../modules/Helper';

const Footer: FC = () => {
	const { t } = useTranslation();

	return (
		<footer className="footer">
			<div className="container ">
				<div className="row " style={{ minHeight: '220px' }}>
					<div
						className="col-12 text-center pt-sm-5"
						style={{
							position: 'relative',
							overflow: 'hidden',
						}}
					>
						<ul id="footer-links">
							<li>
								<a target="_blank" href={Helper.getLink('/contact-us')}>
									{t('keywords.contactUs')}
								</a>
							</li>
							<li>
								<a target="_blank" href={Helper.getLink('/terms')}>
									{t('keywords.termsOfUser')}
								</a>
							</li>
							<li>
								<a target="_blank" href={Helper.getLink('/privacy')}>
									{t('keywords.privacyPolicy')}
								</a>
							</li>
						</ul>
					</div>
					<br />

					<div className="col-12 text-center  pt-4 ">
						<p>
							{t('main.footerAboutUs')}
						</p>
						<p>
							{t('main.footerCopyrightText')}
						</p>
					</div>
				</div>
			</div>
		</footer>
	);
};
export default React.memo(Footer);
